// test1653
(1653 && 0);
